/**
 * KCL Canvas releases, newest first. The first entry is the version shown on the About page,
 * so add a new entry (version + the date it goes live) whenever production is updated.
 */
export interface Release {
  version: string;
  /** The day it went live on canvas.kcl.cloud (YYYY-MM-DD). */
  date: string;
  title: string;
  changes: string[];
}

export const RELEASES: Release[] = [
  {
    version: '1.4',
    date: '2026-10-21',
    title: 'Help and about',
    changes: [
      'About & help in Settings: version, release date, what’s new, and the how-to guide (with a QR code for TVs).',
      'A short address for the guide: canvas.kcl.cloud/help.',
    ],
  },
  {
    version: '1.3.1',
    date: '2026-10-21',
    title: 'Calendars one at a time',
    changes: [
      'Calendar: show all calendars together, or one at a time with tabs and optional rotation.',
      'Edit the name, address and colour of iCal calendars, and the name and address of news feeds.',
      'Weather warnings: each warning is shown once, and warnings for similarly named places elsewhere (La Palma / Palma) no longer appear.',
      'Saved layouts confirm when they are saved or updated.',
      'Planner asks Microsoft for less, so boards and task details are limited less often.',
    ],
  },
  {
    version: '1.3',
    date: '2026-10-21',
    title: 'Screens, sharing, Planner and Power BI',
    changes: [
      'Screens: see every screen on your account and choose what each shows – the main setup, a saved layout, a shared canvas, or several in turn.',
      'Schedules: turn screens off (black) at night or out of hours; a touch wakes them for 15 minutes.',
      'Sharing: groups for family or colleagues, joined by invite link or QR code, and live shared canvases – optionally with your OneDrive photos, Outlook calendars, To Do lists, Planner boards and Power BI.',
      'New widgets: Microsoft Planner (Board, List, Gantt and Calendar views, with people’s photos and task details), Power BI reports and dashboards, and Text.',
      'Install app: step-by-step instructions for computers, phones, tablets and TVs.',
      'Better on slow connections: the next photo and ads are downloaded before they are shown, and screens stay signed in through outages.',
    ],
  },
  {
    version: '1.2',
    date: '2026-10-19',
    title: 'Make it yours',
    changes: [
      'Custom layout: place and resize widgets on a grid, with the mouse, touch or a TV remote.',
      'Widget style (panel colour, glass, border, shadow, corners) and a choice of fonts.',
      'Clock: analogue faces, position and alignment, and up to six more clocks for other time zones.',
      'Calendar styles and “+N more” pop-ups; news story card layouts.',
      'Several Microsoft accounts at once – work and personal together.',
      'Settings regrouped into Appearance, Media, Widgets and Account.',
    ],
  },
  {
    version: '1.1',
    date: '2026-10-18',
    title: 'Where was this taken?',
    changes: ['Location widget: where and when the photo on screen was taken, with a map (three map styles).'],
  },
  {
    version: '1.0',
    date: '2026-10-14',
    title: 'First release',
    changes: [
      'Photos and videos from OneDrive, web links or this device, with transitions, shading and a demo video.',
      'Widgets: clock, weather with official warnings, calendar (iCal and Outlook), lists (with Microsoft To Do) and news.',
      'Layouts for landscape and portrait screens, five themes, saved layouts and custom CSS.',
      'Made for TVs: works with a remote, and signs in by scanning a code with your phone.',
      'Free with an hourly ad, or £10 once for no ads.',
    ],
  },
];

export const CURRENT_RELEASE = RELEASES[0]!;
